import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class DataService {
  organizationCodeValue = new BehaviorSubject(this.organizationCode || "");
  userRoleValue = new BehaviorSubject(this.userRole || "");

  set userRole(value: string) {
    this.userRoleValue.next(value);
  }

  set organizationCode(value: string) {
    this.organizationCodeValue.next(value);
  }

  public isDOZ(): boolean {
    return "DOZ" === this.userRoleValue.getValue();
  }

  public isMZU(): boolean {
    return "MZU" === this.userRoleValue.getValue();
  }

  public isMOZ(): boolean {
    return "MOZ" === this.userRoleValue.getValue();
  }

}
